/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S10_P1Inputs */

const tr_mesafeli_s10_p1 = /** @type {(inputs: Mesafeli_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri, Trendyol, Shopify, Hepsiburada, n11 ve diğer pazaryerlerine ait API anahtarlarını Platform'a kendi onayıyla iletir. Bu bilgiler:`)
};

const en_mesafeli_s10_p1 = /** @type {(inputs: Mesafeli_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Customer transmits the API keys of Trendyol, Shopify, Hepsiburada, n11 and other marketplaces to the Platform with his own approval. This information:`)
};

const de_mesafeli_s10_p1 = /** @type {(inputs: Mesafeli_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Kunde übermittelt die API-Schlüssel von Trendyol, Shopify, Hepsiburada, n11 und weiteren Marktplätzen mit seiner eigenen Zustimmung an die Plattform. Diese Daten:`)
};

const ru_mesafeli_s10_p1 = /** @type {(inputs: Mesafeli_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Клиент передаёт API-ключи Trendyol, Shopify, Hepsiburada, n11 и других маркетплейсов на Платформу с собственного согласия. Эти данные:`)
};

/**
* | output |
* | --- |
* | "The Customer transmits the API keys of Trendyol, Shopify, Hepsiburada, n11 and other marketplaces to the Platform with his own approval. This information:" |
*
* @param {Mesafeli_S10_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s10_p1 = /** @type {((inputs?: Mesafeli_S10_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S10_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s10_p1(inputs)
	if (locale === "de") return de_mesafeli_s10_p1(inputs)
	if (locale === "ru") return ru_mesafeli_s10_p1(inputs)
	return tr_mesafeli_s10_p1(inputs)
});